/** @file tileHexOf: a colour as `#rrggbb` (opaque) or `#rrggbbaa` for the hex field and palette titles. */
import type { Rgba } from '@zilo/pose3d-image-io/types/image';

/** Lower-case hex; the alpha byte is written only when the colour is not opaque. */
export function tileHexOf(color: Rgba): string {
  const parts = color[3] === 255 ? color.slice(0, 3) : color;
  return `#${parts.map((c) => c.toString(16).padStart(2, '0')).join('')}`;
}
